<footer id="footer" class="footer position-relative">
    <div class="container footer-top">
        <div class="row gy-3 gy-md-4">
            <div class="col-lg-4 col-md-4 footer-about">
                <a href="index.html" class="logo d-flex align-items-center">
                    <span class="sitename">All-In-One Invoice</span>
                </a>
                <div class="footer-contact pt-3">
                    <p>Kitchener, ON, Canada</p>
                    <p class="mt-3">
                        <strong>Phone:</strong>
                        <a href="tel:+16476763338"><span> +1 647 676 3338</span></a>
                    </p>
                    <p>
                        <strong>Email:</strong>
                        <a href="mailto:allinoneinvoice@outlook.com"><span> allinoneinvoice&#64;outlook.com</span></a>
                    </p>
                </div>
                <div class="social-links d-flex mt-4">
                    <!-- <a href=""><i class="bi bi-twitter-x"></i></a>
                    <a href=""><i class="bi bi-facebook"></i></a> -->
                    <a href="https://www.instagram.com/allinoneinvoice/" target="_blank"><i
                            class="bi bi-instagram"></i></a>
                    <a href="https://www.linkedin.com/company/keyknot-technology-inc" target="_blank"><i
                            class="bi bi-linkedin"></i></a>
                </div>
            </div>

            <div class="col-lg-4 col-md-4 footer-links">
                <h4>Useful Links</h4>
                <ul>
                    <li><a routerLink="/home">Home</a></li>
                    <li><a routerLink="/about">About us</a></li>
                    <li><a routerLink="/services">Services</a></li>
                    <li><a routerLink="/pricing">Pricing</a></li>
                    <li><a routerLink="/contact">Contact</a></li>
                </ul>
            </div>

            <!-- <div class="col-lg-2 col-md-4 footer-links">
                <h4>Our Services</h4>
                <ul>
                    <li><a routerLink="/services">Professional Design</a></li>
                    <li><a routerLink="/services">Tax Calculation</a></li>
                    <li><a routerLink="/services">Business Details</a></li>
                    <li><a routerLink="/services">Invoice Customization</a></li>
                    <li><a routerLink="/services">Shipping Charges and Discounts</a></li>
                    <li><a routerLink="/services">Live Calculations</a></li>
                </ul>
            </div> -->

            <div class="col-lg-4 col-md-12 footer-newsletter">
                <h4>Our Newsletter</h4>
                <p>Subscribe to our newsletter and receive the latest news about our products and services!</p>
                <form [formGroup]="subscriberForm" (ngSubmit)="onSubscribe()" novalidate autocomplete="off">
                    <div class="newsletter-form">
                        <input type="email" formControlName="email" placeholder="Email Address"
                            [ngClass]="{'is-invalid': subscriberForm.get('email')?.invalid && (subscriberForm.get('email')?.touched) }">

                        <input type="submit" class="btn btn-get-started" [disabled]="subscriberForm.invalid">
                    </div>
                    @if(isLoading){
                    <div class="loading">Loading...</div>
                    }

                    @if(isError){
                    <div class="error-message">{{errorMsg}}</div>
                    }

                    @if(isSuccess){
                    <div class="sent-message">Your subscription request has been sent. Thank you!</div>
                    }
                </form>
            </div>
        </div>
    </div>

    <div class="container copyright text-center mt-4">
        <p>© <span>Copyright</span> <strong class="px-1 sitename">All-In-One Invoice</strong><span>All Rights
                Reserved</span></p>
        <div class="credits">
            Managed by <a href="https://keyknot.ca/" target="_blank">Keyknot Technology Inc.</a>
        </div>
        <div class="credits">
            <a routerLink="/policy" target="_blank">Cookie and Data Storage Policy</a>
        </div>
    </div>

</footer>